import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import * as actions from './actions'
import * as mutations from './mutaions'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userInfo: null, //登录状态,
        cartCount: '', // 购物车数量
        daigouNum: 0, // 代购商品数量
        zijiaNum: 0,  // 自家商品数量
        toPageName: null, // 登入后跳转到当前页
        exchangeRate: '', //汇率
        imgData: null, //图片搜索结果
        loading: false
    },
    mutations,
    actions,
    modules: {
        // 购物车
    },
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })]
})
